import React, { useState } from 'react';
import classnames from 'classnames'

const BringzzTabPanel = ({ id, isActive, children, className }) => {
    return (
        <div className={classnames(className, "bg-white")}>{children}</div>
    )
}

export default BringzzTabPanel